webpackJsonp([232751019619440],{

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactComponentQueries = __webpack_require__(9);
	
	var _reactComponentQueries2 = _interopRequireDefault(_reactComponentQueries);
	
	var _rebass = __webpack_require__(6);
	
	var _meta = __webpack_require__(55);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _overlay = __webpack_require__(34);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _image = __webpack_require__(20);
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _reactComponentQueries2.default)(function (_ref) {
	  var width = _ref.width;
	
	  var layoutProps = function mapWidthToLayoutProps() {
	    var dFault = {
	      image: {
	        w: "100%"
	      },
	      text: {
	        f: 11,
	        w: 1,
	        mb: 15
	      },
	      contact: {
	        f: 11,
	        w: 1
	      }
	    };
	
	    if (width > 1000) {
	      return {
	        image: {
	          w: "60%"
	        },
	        text: {
	          f: 8,
	          w: 2 / 3
	        },
	        contact: {
	          f: 6,
	          w: 1 / 3,
	          justify: "center"
	        }
	      };
	    }
	
	    if (width > 500) {
	      return {
	        image: {
	          w: "80%"
	        },
	        text: {
	          f: 9,
	          w: 1,
	          mb: 13
	        },
	        contact: {
	          f: 8,
	          w: 1
	        }
	      };
	    }
	
	    return dFault;
	  }();
	
	  return {
	    layoutProps: layoutProps
	  };
	})(function (props) {
	  var _props$data$allAbout$ = props.data.allAbout.edges[0].node,
	      contact = _props$data$allAbout$.contact,
	      text = _props$data$allAbout$.text,
	      image = _props$data$allAbout$.image;
	  var globalSeo = props.data.globalSeo;
	  var layoutProps = props.layoutProps;
	
	  return _react2.default.createElement(
	    _rebass.Flex,
	    {
	      style: { backgroundColor: "transparent" },
	      justify: "center",
	      pt: "0vh"
	    },
	    _react2.default.createElement(
	      _rebass.Box,
	      { w: "80%" },
	      _react2.default.createElement(_meta2.default, globalSeo),
	      _react2.default.createElement(_overlay2.default, { elements: [["RO"], ["Architecten"], ["&"], ["AD"]] }),
	      _react2.default.createElement(
	        _rebass.Box,
	        { w: layoutProps.image.w, pb: "5rem" },
	        _react2.default.createElement(_image2.default, { file: image })
	      ),
	      _react2.default.createElement(
	        _rebass.Flex,
	        { wrap: true, justify: "space-around" },
	        _react2.default.createElement(_rebass.Box, {
	          pr: "3vw",
	          f: layoutProps.text.f,
	          w: layoutProps.text.w,
	          mb: layoutProps.text.mb,
	          dangerouslySetInnerHTML: { __html: text }
	        }),
	        _react2.default.createElement(
	          _rebass.Box,
	          { f: layoutProps.contact.f, w: layoutProps.contact.w },
	          _react2.default.createElement(
	            _rebass.Flex,
	            { justify: layoutProps.contact.justify },
	            _react2.default.createElement(_rebass.Box, { dangerouslySetInnerHTML: { __html: contact } })
	          )
	        )
	      )
	    )
	  );
	});
	// import Link from "gatsby-link";
	// import Helmet from "react-helmet";
	// import styled from "styled-components";
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-over-js-8bae2f68135125048757.js